import { render } from "./MetricsForm.vue?vue&type=template&id=2867e758&scoped=true"
import script from "./MetricsForm.vue?vue&type=script&lang=js"
export * from "./MetricsForm.vue?vue&type=script&lang=js"

import "./MetricsForm.vue?vue&type=style&index=0&id=2867e758&lang=scss&scoped=true"
import "./MetricsForm.vue?vue&type=style&index=1&id=2867e758&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2867e758"]])

export default __exports__